import { useState, useEffect, useCallback } from 'react';
import { PasswordInput } from '../components/PasswordInput';

const SERVER_URL = window.location.origin;

export function AdminPage({ token, agent, onLogout }) {
  const [tab, setTab] = useState('agents');

  const s = {
    wrap: { minHeight: '100vh', background: '#f5f5f5', fontFamily: 'sans-serif' },
    topbar: { background: '#fff', borderBottom: '1px solid #e5e5e5', padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    title: { fontSize: 18, fontWeight: 700, color: '#111' },
    topRight: { display: 'flex', gap: 10, alignItems: 'center', fontSize: 13, color: '#666' },
    tabs: { display: 'flex', gap: 4, padding: '0 24px', background: '#fff', borderBottom: '1px solid #e5e5e5' },
    tab: (active) => ({
      padding: '12px 16px', cursor: 'pointer', fontSize: 13, fontWeight: 600,
      color: active ? '#185FA5' : '#888', borderBottom: active ? '2px solid #185FA5' : '2px solid transparent'
    }),
    btn: (v) => ({
      padding: '7px 14px', borderRadius: 7, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500,
      background: v === 'primary' ? '#185FA5' : v === 'danger' ? '#E24B4A' : v === 'success' ? '#1D9E75' : '#f0f0f0',
      color: (v && v !== 'default') ? '#fff' : '#333'
    }),
    container: { padding: 24, maxWidth: 1200, margin: '0 auto' },
    headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
    sectionTitle: { fontSize: 16, fontWeight: 600, color: '#333' },
    tableWrap: { background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
    th: { textAlign: 'left', padding: '12px 14px', borderBottom: '1px solid #eee', background: '#fafafa', fontWeight: 600, color: '#555', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.3 },
    td: { padding: '12px 14px', borderBottom: '1px solid #f0f0f0', color: '#333', verticalAlign: 'middle' },
    tdActions: { padding: '10px 14px', borderBottom: '1px solid #f0f0f0', textAlign: 'right', whiteSpace: 'nowrap' },
    badge: (color) => ({
      display: 'inline-block', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600,
      background: color === 'admin' ? '#E6F1FB' : color === 'agent' ? '#F0F0F0' : color === 'enabled' ? '#E1F5EE' : '#FCEBEB',
      color: color === 'admin' ? '#0C447C' : color === 'agent' ? '#666' : color === 'enabled' ? '#085041' : '#791F1F'
    }),
    outcomeBadge: (outcome) => {
      const map = {
        completed: { bg: '#E1F5EE', color: '#085041', text: 'Uspešno' },
        rejected: { bg: '#FCEBEB', color: '#791F1F', text: 'Odbijeno' },
        cancelled: { bg: '#f0f0f0', color: '#666', text: 'Otkazano' },
        client_offline: { bg: '#FAEEDA', color: '#633806', text: 'Klijent offline' },
        aborted: { bg: '#FCEBEB', color: '#791F1F', text: 'Prekinuto' }
      };
      const m = map[outcome] || { bg: '#f0f0f0', color: '#888', text: outcome || 'U toku' };
      return { display: 'inline-block', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: m.bg, color: m.color, label: m.text };
    },
    actionBtn: { padding: '4px 8px', margin: '0 2px', borderRadius: 4, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#333' },
    error: { background: '#FCEBEB', color: '#791F1F', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13 },
    empty: { padding: 40, textAlign: 'center', color: '#999' },
    modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 },
    modal: { background: '#fff', borderRadius: 12, padding: 24, width: '100%', maxWidth: 400, boxShadow: '0 8px 32px rgba(0,0,0,0.16)' },
    modalTitle: { fontSize: 17, fontWeight: 700, marginBottom: 16, color: '#111' },
    label: { fontSize: 12, fontWeight: 500, color: '#666', marginBottom: 4, display: 'block' },
    input: { width: '100%', padding: '9px 11px', fontSize: 13, border: '1px solid #ddd', borderRadius: 7, outline: 'none', marginBottom: 12, boxSizing: 'border-box' },
    select: { width: '100%', padding: '9px 11px', fontSize: 13, border: '1px solid #ddd', borderRadius: 7, outline: 'none', marginBottom: 12, boxSizing: 'border-box', background: '#fff' },
    modalActions: { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6 },
    statCards: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 20 },
    statCard: { background: '#fff', borderRadius: 10, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' },
    statValue: { fontSize: 24, fontWeight: 700, color: '#111' },
    statLabel: { fontSize: 12, color: '#888', marginTop: 4 },
    filterRow: { display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap' },
    filterInput: { padding: '7px 10px', fontSize: 13, border: '1px solid #ddd', borderRadius: 7, outline: 'none', minWidth: 140 },
    warningBox: { background: '#FAEEDA', color: '#633806', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13 },
    successBox: { background: '#E1F5EE', color: '#085041', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13 }
  };

  return (
    <div style={s.wrap}>
      <div style={s.topbar}>
        <div style={s.title}>Screen Support — Admin panel</div>
        <div style={s.topRight}>
          <span>{agent?.fullName || agent?.username}</span>
          <a href="/agent" style={{ color: '#185FA5', textDecoration: 'none', fontSize: 12 }}>← Nazad na agent</a>
          <button style={s.btn()} onClick={onLogout}>Odjavi se</button>
        </div>
      </div>

      <div style={s.tabs}>
        <div style={s.tab(tab === 'agents')} onClick={() => setTab('agents')}>Agenti</div>
        <div style={s.tab(tab === 'history')} onClick={() => setTab('history')}>Istorija sesija</div>
        <div style={s.tab(tab === 'audit')} onClick={() => setTab('audit')}>Audit log</div>
        <div style={s.tab(tab === 'data')} onClick={() => setTab('data')}>Upravljanje podacima</div>
        <div style={s.tab(tab === 'ratings')} onClick={() => setTab('ratings')}>Ocene</div>
      </div>

      <div style={s.container}>
        {tab === 'agents' && <AgentsTab token={token} agent={agent} styles={s} />}
        {tab === 'history' && <HistoryTab token={token} styles={s} />}
        {tab === 'audit' && <AuditTab token={token} styles={s} />}
        {tab === 'data' && <DataManagementTab token={token} styles={s} />}
        {tab === 'ratings' && <RatingsTab token={token} styles={s} />}
      </div>
    </div>
  );
}

// ============ TAB: AGENTI ============

function AgentsTab({ token, agent, styles: s }) {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [resetPasswordAgent, setResetPasswordAgent] = useState(null);

  const authHeaders = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  const fetchAgents = useCallback(async () => {
    try {
      const res = await fetch(`${SERVER_URL}/api/admin/agents`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (!res.ok) throw new Error('Neuspeh preuzimanja');
      setAgents(await res.json());
      setError('');
    } catch (e) {
      setError('Greška pri učitavanju liste agenata');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchAgents(); }, [fetchAgents]);

  const handleAdd = async (data) => {
    const res = await fetch(`${SERVER_URL}/api/admin/agents`, { method: 'POST', headers: authHeaders, body: JSON.stringify(data) });
    const body = await res.json();
    if (!res.ok) throw new Error(body.error || 'Greška');
    setShowAddModal(false);
    fetchAgents();
  };

  const handleUpdate = async (username, changes) => {
    const res = await fetch(`${SERVER_URL}/api/admin/agents/${encodeURIComponent(username)}`, { method: 'PATCH', headers: authHeaders, body: JSON.stringify(changes) });
    const body = await res.json();
    if (!res.ok) throw new Error(body.error || 'Greška');
    fetchAgents();
  };

  const handleToggleEnabled = async (a) => {
    try { await handleUpdate(a.username, { enabled: !a.enabled }); } catch (e) { alert(e.message); }
  };

  const handleRoleChange = async (a, newRole) => {
    if (newRole === a.role) return;
    if (!window.confirm(`Promeniti ulogu za ${a.username} u "${newRole}"?`)) return;
    try { await handleUpdate(a.username, { role: newRole }); } catch (e) { alert(e.message); }
  };

  const handleToggleTrainee = async (a) => {
    try { await handleUpdate(a.username, { isTrainee: !a.isTrainee }); } catch (e) { alert(e.message); }
  };

  const handleDelete = async (a) => {
    if (!window.confirm(`Trajno obrisati agenta ${a.username}?`)) return;
    try {
      const res = await fetch(`${SERVER_URL}/api/admin/agents/${encodeURIComponent(a.username)}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      const body = await res.json();
      if (!res.ok) throw new Error(body.error || 'Greška');
      fetchAgents();
    } catch (e) { alert(e.message); }
  };

  const handleResetPassword = async (newPassword) => {
    await handleUpdate(resetPasswordAgent.username, { password: newPassword });
    setResetPasswordAgent(null);
  };

  const formatDate = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleString('sr-RS', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <>
      <div style={s.headerRow}>
        <div style={s.sectionTitle}>Agenti ({agents.length})</div>
        <button style={s.btn('primary')} onClick={() => setShowAddModal(true)}>+ Dodaj agenta</button>
      </div>

      {error && <div style={s.error}>{error}</div>}

      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Korisničko ime</th>
              <th style={s.th}>Puno ime</th>
              <th style={s.th}>Uloga</th>
              <th style={s.th}>Pripravnik</th>
              <th style={s.th}>Status</th>
              <th style={s.th}>Kreiran</th>
              <th style={s.th}>Poslednja prijava</th>
              <th style={{ ...s.th, textAlign: 'right' }}>Akcije</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} style={s.empty}>Učitavanje...</td></tr>}
            {!loading && agents.length === 0 && <tr><td colSpan={8} style={s.empty}>Nema agenata</td></tr>}
            {!loading && agents.map(a => {
              const isSelf = a.username === agent?.username;
              return (
                <tr key={a.username}>
                  <td style={s.td}><strong>{a.username}</strong>{isSelf && <span style={{ color: '#999', fontSize: 11, marginLeft: 6 }}>(vi)</span>}</td>
                  <td style={s.td}>{a.fullName || '—'}</td>
                  <td style={s.td}>
                    <select
                      style={{ padding: '3px 6px', fontSize: 12, border: '1px solid #ddd', borderRadius: 5, background: '#fff' }}
                      value={a.role}
                      onChange={e => handleRoleChange(a, e.target.value)}
                      disabled={isSelf}
                    >
                      <option value="agent">Agent</option>
                      <option value="admin">Administrator</option>
                      <option value="supervisor">Supervizor</option>
                    </select>
                  </td>
                  <td style={s.td}>
                    {a.role === 'agent' ? (
                      <button
                        style={{ ...s.actionBtn, background: a.isTrainee ? '#FAF3E8' : '#fff', color: a.isTrainee ? '#8A5A1F' : '#999', borderColor: a.isTrainee ? '#EAD3B0' : '#ddd' }}
                        onClick={() => handleToggleTrainee(a)}
                      >
                        {a.isTrainee ? '🎓 Da' : 'Ne'}
                      </button>
                    ) : '—'}
                  </td>
                  <td style={s.td}><span style={s.badge(a.enabled ? 'enabled' : 'disabled')}>{a.enabled ? 'Aktivan' : 'Onemogućen'}</span></td>
                  <td style={s.td}>{formatDate(a.createdAt)}</td>
                  <td style={s.td}>{formatDate(a.lastLogin)}</td>
                  <td style={s.tdActions}>
                    <button style={s.actionBtn} onClick={() => setResetPasswordAgent(a)}>Reset lozinke</button>
                    <button style={s.actionBtn} onClick={() => handleToggleEnabled(a)} disabled={isSelf}>{a.enabled ? 'Onemogući' : 'Omogući'}</button>
                    <button style={{ ...s.actionBtn, color: '#791F1F', borderColor: '#F09595' }} onClick={() => handleDelete(a)} disabled={isSelf}>Obriši</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {showAddModal && <AddAgentModal onClose={() => setShowAddModal(false)} onSubmit={handleAdd} styles={s} />}
      {resetPasswordAgent && <ResetPasswordModal agent={resetPasswordAgent} onClose={() => setResetPasswordAgent(null)} onSubmit={handleResetPassword} styles={s} />}
    </>
  );
}

function AddAgentModal({ onClose, onSubmit, styles: s }) {
  const [username, setUsername] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('agent');
  const [isTrainee, setIsTrainee] = useState(false);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Lozinka mora imati bar 6 znakova'); return; }
    setSaving(true);
    try {
      await onSubmit({ username: username.trim(), fullName: fullName.trim(), password, role, isTrainee: role === 'agent' ? isTrainee : false });
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div style={s.modalOverlay} onClick={onClose}>
      <form style={s.modal} onClick={e => e.stopPropagation()} onSubmit={submit}>
        <div style={s.modalTitle}>Dodaj agenta</div>
        {error && <div style={s.error}>{error}</div>}
        <label style={s.label}>Korisničko ime</label>
        <input style={s.input} value={username} onChange={e => setUsername(e.target.value)} autoFocus disabled={saving} />
        <label style={s.label}>Puno ime</label>
        <input style={s.input} value={fullName} onChange={e => setFullName(e.target.value)} placeholder="opciono" disabled={saving} />
        <label style={s.label}>Lozinka (min 6 znakova)</label>
        <PasswordInput style={s.input} value={password} onChange={e => setPassword(e.target.value)} disabled={saving} />
        <label style={s.label}>Uloga</label>
        <select style={s.select} value={role} onChange={e => setRole(e.target.value)} disabled={saving}>
          <option value="agent">Agent</option>
          <option value="admin">Administrator</option>
          <option value="supervisor">Supervizor</option>
        </select>
        {role === 'agent' && (
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#555', marginBottom: 12, marginTop: -6 }}>
            <input type="checkbox" checked={isTrainee} onChange={e => setIsTrainee(e.target.checked)} disabled={saving} />
            Pripravnik (obuka)
          </label>
        )}
        <div style={s.modalActions}>
          <button type="button" style={s.btn()} onClick={onClose} disabled={saving}>Otkaži</button>
          <button type="submit" style={s.btn('primary')} disabled={saving || !username || !password}>{saving ? 'Kreiranje...' : 'Kreiraj'}</button>
        </div>
      </form>
    </div>
  );
}

function ResetPasswordModal({ agent, onClose, onSubmit, styles: s }) {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Lozinka mora imati bar 6 znakova'); return; }
    if (password !== password2) { setError('Lozinke se ne poklapaju'); return; }
    setSaving(true);
    try {
      await onSubmit(password);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div style={s.modalOverlay} onClick={onClose}>
      <form style={s.modal} onClick={e => e.stopPropagation()} onSubmit={submit}>
        <div style={s.modalTitle}>Reset lozinke — {agent.username}</div>
        {error && <div style={s.error}>{error}</div>}
        <label style={s.label}>Nova lozinka</label>
        <PasswordInput style={s.input} value={password} onChange={e => setPassword(e.target.value)} autoFocus disabled={saving} />
        <label style={s.label}>Potvrdi lozinku</label>
        <PasswordInput style={s.input} value={password2} onChange={e => setPassword2(e.target.value)} disabled={saving} />
        <div style={s.modalActions}>
          <button type="button" style={s.btn()} onClick={onClose} disabled={saving}>Otkaži</button>
          <button type="submit" style={s.btn('primary')} disabled={saving || !password || !password2}>{saving ? 'Postavljanje...' : 'Postavi lozinku'}</button>
        </div>
      </form>
    </div>
  );
}

// ============ TAB: ISTORIJA SESIJA ============

function HistoryTab({ token, styles: s }) {
  const [sessions, setSessions] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [agentFilter, setAgentFilter] = useState('');
  const [agentsList, setAgentsList] = useState([]);

  useEffect(() => {
    fetch(`${SERVER_URL}/api/admin/agents`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json()).then(setAgentsList).catch(() => {});
  }, [token]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const qs = agentFilter ? `?agent=${encodeURIComponent(agentFilter)}` : '';
    const [histRes, statsRes] = await Promise.all([
      fetch(`${SERVER_URL}/api/sessions/history${qs}`, { headers: { 'Authorization': `Bearer ${token}` } }),
      fetch(`${SERVER_URL}/api/sessions/stats${qs}`, { headers: { 'Authorization': `Bearer ${token}` } })
    ]);
    setSessions(await histRes.json());
    setStats(await statsRes.json());
    setLoading(false);
  }, [token, agentFilter]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const formatDate = (iso) => iso ? new Date(iso).toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';
  const formatDuration = (sec) => {
    if (sec == null) return '—';
    const s = Math.round(sec);
    if (s < 60) return `${s}s`;
    return `${Math.floor(s / 60)}m ${s % 60}s`;
  };

  return (
    <>
      <div style={s.statCards}>
        <div style={s.statCard}><div style={s.statValue}>{stats?.total_sessions ?? '—'}</div><div style={s.statLabel}>Ukupno sesija</div></div>
        <div style={s.statCard}><div style={s.statValue}>{stats?.completed ?? 0}</div><div style={s.statLabel}>Uspešno završeno</div></div>
        <div style={s.statCard}><div style={s.statValue}>{stats?.rejected ?? 0}</div><div style={s.statLabel}>Odbijeno</div></div>
        <div style={s.statCard}><div style={s.statValue}>{formatDuration(stats?.avg_wait_seconds)}</div><div style={s.statLabel}>Prosečno čekanje</div></div>
        <div style={s.statCard}><div style={s.statValue}>{formatDuration(stats?.avg_sharing_seconds)}</div><div style={s.statLabel}>Prosečno trajanje</div></div>
      </div>

      <div style={s.headerRow}>
        <div style={s.sectionTitle}>Istorija sesija ({sessions.length})</div>
        <div style={s.filterRow}>
          <select style={{ ...s.select, marginBottom: 0, width: 200 }} value={agentFilter} onChange={e => setAgentFilter(e.target.value)}>
            <option value="">Svi agenti</option>
            {agentsList.map(a => <option key={a.username} value={a.username}>{a.fullName || a.username}</option>)}
          </select>
        </div>
      </div>

      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Kod</th>
              <th style={s.th}>Agent</th>
              <th style={s.th}>Opis</th>
              <th style={s.th}>Uređaj</th>
              <th style={s.th}>Zahtev</th>
              <th style={s.th}>Čekanje</th>
              <th style={s.th}>Trajanje</th>
              <th style={s.th}>Ishod</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} style={s.empty}>Učitavanje...</td></tr>}
            {!loading && sessions.length === 0 && <tr><td colSpan={8} style={s.empty}>Nema podataka</td></tr>}
            {!loading && sessions.map(sess => {
              const waitSec = sess.sharing_started_at && sess.requested_at
                ? (new Date(sess.sharing_started_at) - new Date(sess.requested_at)) / 1000 : null;
              const shareSec = sess.ended_at && sess.sharing_started_at
                ? (new Date(sess.ended_at) - new Date(sess.sharing_started_at)) / 1000 : null;
              const outcome = s.outcomeBadge(sess.outcome);
              return (
                <tr key={sess.id}>
                  <td style={s.td}><strong style={{ fontFamily: 'monospace' }}>{sess.code}</strong></td>
                  <td style={s.td}>{sess.agent_username || '—'}</td>
                  <td style={{ ...s.td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sess.description || <span style={{ color: '#999' }}>bez opisa</span>}</td>
                  <td style={s.td}>{sess.device_model || '—'}</td>
                  <td style={s.td}>{formatDate(sess.requested_at)}</td>
                  <td style={s.td}>{formatDuration(waitSec)}</td>
                  <td style={s.td}>{formatDuration(shareSec)}</td>
                  <td style={s.td}><span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: outcome.bg, color: outcome.color }}>{outcome.label}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

// ============ TAB: AUDIT LOG ============

function AuditTab({ token, styles: s }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [eventFilter, setEventFilter] = useState('');

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    const qs = eventFilter ? `?eventType=${encodeURIComponent(eventFilter)}` : '';
    const res = await fetch(`${SERVER_URL}/api/admin/audit-log${qs}`, { headers: { 'Authorization': `Bearer ${token}` } });
    setLogs(await res.json());
    setLoading(false);
  }, [token, eventFilter]);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);

  const formatDate = (iso) => new Date(iso).toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });

  const eventLabel = (type) => {
    const map = {
      login: 'Prijava', login_failed: 'Neuspela prijava', login_failed_disabled: 'Prijava (onemogućen)',
      agent_created: 'Agent kreiran', agent_updated: 'Agent izmenjen', agent_deleted: 'Agent obrisan',
      session_requested: 'Zahtev podnet', session_accepted: 'Zahtev prihvaćen', session_rejected: 'Zahtev odbijen',
      session_cancelled: 'Zahtev otkazan', session_sharing_started: 'Deljenje počelo', session_ended: 'Sesija završena'
    };
    return map[type] || type;
  };

  const eventTypes = ['login', 'login_failed', 'agent_created', 'agent_updated', 'agent_deleted',
    'session_requested', 'session_accepted', 'session_rejected', 'session_cancelled', 'session_sharing_started', 'session_ended'];

  return (
    <>
      <div style={s.headerRow}>
        <div style={s.sectionTitle}>Audit log ({logs.length})</div>
        <div style={s.filterRow}>
          <select style={{ ...s.select, marginBottom: 0, width: 220 }} value={eventFilter} onChange={e => setEventFilter(e.target.value)}>
            <option value="">Svi tipovi događaja</option>
            {eventTypes.map(t => <option key={t} value={t}>{eventLabel(t)}</option>)}
          </select>
        </div>
      </div>

      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Vreme</th>
              <th style={s.th}>Događaj</th>
              <th style={s.th}>Ko</th>
              <th style={s.th}>Na koga/šta</th>
              <th style={s.th}>Detalji</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} style={s.empty}>Učitavanje...</td></tr>}
            {!loading && logs.length === 0 && <tr><td colSpan={5} style={s.empty}>Nema zapisa</td></tr>}
            {!loading && logs.map(log => (
              <tr key={log.id}>
                <td style={s.td}>{formatDate(log.timestamp)}</td>
                <td style={s.td}><span style={s.badge('agent')}>{eventLabel(log.event_type)}</span></td>
                <td style={s.td}>{log.actor || '—'}</td>
                <td style={s.td}>{log.target || '—'}</td>
                <td style={{ ...s.td, fontSize: 11, color: '#888', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {log.details || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}


// ============ TAB: UPRAVLJANJE PODACIMA ============

function DataManagementTab({ token, styles: s }) {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [agentsList, setAgentsList] = useState([]);
  const [filterAgent, setFilterAgent] = useState('');
  const [filterCode, setFilterCode] = useState('');
  const [filterDateFrom, setFilterDateFrom] = useState('');
  const [filterDateTo, setFilterDateTo] = useState('');
  const [selected, setSelected] = useState(new Set());
  const [message, setMessage] = useState(null);

  const [auditEventType, setAuditEventType] = useState('');
  const [auditActor, setAuditActor] = useState('');
  const [auditDateFrom, setAuditDateFrom] = useState('');
  const [auditDateTo, setAuditDateTo] = useState('');

  useEffect(() => {
    fetch(`${SERVER_URL}/api/admin/agents`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json()).then(setAgentsList).catch(() => {});
  }, [token]);

  const fetchSessions = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filterAgent) params.set('agent', filterAgent);
    if (filterCode) params.set('code', filterCode);
    if (filterDateFrom) params.set('dateFrom', filterDateFrom + 'T00:00:00.000Z');
    if (filterDateTo) params.set('dateTo', filterDateTo + 'T23:59:59.999Z');
    params.set('limit', '200');

    const res = await fetch(`${SERVER_URL}/api/admin/sessions-overview?${params}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (res.ok) setSessions(await res.json());
    setLoading(false);
  }, [token, filterAgent, filterCode, filterDateFrom, filterDateTo]);

  useEffect(() => { fetchSessions(); }, [fetchSessions]);

  const toggleSelect = (code) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(code)) next.delete(code); else next.add(code);
      return next;
    });
  };

  const toggleSelectAll = () => {
    if (selected.size === sessions.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(sessions.map(s2 => s2.code)));
    }
  };

  const deleteSingleSession = async (code) => {
    if (!window.confirm(`Trajno obrisati sesiju ${code}? Ovo briše chat poruke, snimke ekrana (i fajlove sa diska) i istoriju sesije. Ne može se poništiti.`)) return;
    try {
      const res = await fetch(`${SERVER_URL}/api/admin/sessions/${encodeURIComponent(code)}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const body = await res.json();
      if (!res.ok) { alert(body.error || 'Greška'); return; }
      setMessage(`Sesija ${code} obrisana (${body.filesDeleted} fajlova sa diska).`);
      fetchSessions();
    } catch (e) {
      alert('Greška pri brisanju');
    }
  };

  const deleteSelected = async () => {
    if (selected.size === 0) return;
    if (!window.confirm(`Trajno obrisati ${selected.size} selektovanih sesija sa svim podacima? Ne može se poništiti.`)) return;
    try {
      const res = await fetch(`${SERVER_URL}/api/admin/sessions/bulk-delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ codes: Array.from(selected) })
      });
      const body = await res.json();
      if (!res.ok) { alert(body.error || 'Greška'); return; }
      setMessage(`Obrisano ${body.deletedCount} sesija (${body.filesDeleted} fajlova sa diska).`);
      setSelected(new Set());
      fetchSessions();
    } catch (e) {
      alert('Greška pri brisanju');
    }
  };

  const deleteAllFiltered = async () => {
    const hasFilter = filterAgent || filterCode || filterDateFrom || filterDateTo;
    const warningMsg = hasFilter
      ? `Trajno obrisati SVE sesije koje odgovaraju trenutnom filteru (${sessions.length} sesija)? Ne može se poništiti.`
      : `Trajno obrisati BAŠ SVE sesije iz cele baze (${sessions.length})? Ovo briše kompletnu istoriju, chat i snimke. Ne može se poništiti.`;
    if (!window.confirm(warningMsg)) return;
    if (!hasFilter && !window.confirm('Ovo je nepovratna akcija nad CELOKUPNOM bazom. Da li si potpuno siguran?')) return;

    try {
      const res = await fetch(`${SERVER_URL}/api/admin/sessions/bulk-delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          agentUsername: filterAgent || undefined,
          dateFrom: filterDateFrom ? filterDateFrom + 'T00:00:00.000Z' : undefined,
          dateTo: filterDateTo ? filterDateTo + 'T23:59:59.999Z' : undefined
        })
      });
      const body = await res.json();
      if (!res.ok) { alert(body.error || 'Greška'); return; }
      setMessage(`Obrisano ${body.deletedCount} sesija (${body.filesDeleted} fajlova sa diska).`);
      setSelected(new Set());
      fetchSessions();
    } catch (e) {
      alert('Greška pri brisanju');
    }
  };

  const deleteAuditFiltered = async (allFlag) => {
    const msg = allFlag
      ? 'Trajno obrisati CEO audit log? Ne može se poništiti.'
      : 'Obrisati audit log zapise po zadatom filteru? Ne može se poništiti.';
    if (!window.confirm(msg)) return;

    try {
      const res = await fetch(`${SERVER_URL}/api/admin/audit-log/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(allFlag ? { all: true } : {
          eventType: auditEventType || undefined,
          actor: auditActor || undefined,
          dateFrom: auditDateFrom ? auditDateFrom + 'T00:00:00.000Z' : undefined,
          dateTo: auditDateTo ? auditDateTo + 'T23:59:59.999Z' : undefined
        })
      });
      const body = await res.json();
      if (!res.ok) { alert(body.error || 'Greška'); return; }
      setMessage(`Obrisano ${body.deletedCount} audit log zapisa.`);
    } catch (e) {
      alert('Greška pri brisanju');
    }
  };

  const formatDate = (iso) => iso ? new Date(iso).toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';

  return (
    <>
      <div style={s.warningBox}>
        ⚠️ Brisanje ovde je trajno i nepovratno — briše se iz baze i sa diska (snimci ekrana). Dostupno samo administratorima.
      </div>

      {message && <div style={s.successBox}>{message}</div>}

      <div style={s.headerRow}>
        <div style={s.sectionTitle}>Sesije ({sessions.length})</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={s.btn('danger')} onClick={deleteSelected} disabled={selected.size === 0}>
            Obriši selektovano ({selected.size})
          </button>
          <button style={s.btn('danger')} onClick={deleteAllFiltered}>
            {filterAgent || filterCode || filterDateFrom || filterDateTo ? 'Obriši sve po filteru' : 'Obriši sve sesije'}
          </button>
        </div>
      </div>

      <div style={s.filterRow}>
        <input style={s.filterInput} placeholder="Pretraga po kodu..." value={filterCode} onChange={e => setFilterCode(e.target.value)} />
        <select style={{ ...s.filterInput, background: '#fff' }} value={filterAgent} onChange={e => setFilterAgent(e.target.value)}>
          <option value="">Svi agenti</option>
          {agentsList.map(a => <option key={a.username} value={a.username}>{a.fullName || a.username}</option>)}
        </select>
        <input style={s.filterInput} type="date" value={filterDateFrom} onChange={e => setFilterDateFrom(e.target.value)} title="Od datuma" />
        <input style={s.filterInput} type="date" value={filterDateTo} onChange={e => setFilterDateTo(e.target.value)} title="Do datuma" />
      </div>

      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: 30 }}>
                <input type="checkbox" checked={sessions.length > 0 && selected.size === sessions.length} onChange={toggleSelectAll} />
              </th>
              <th style={s.th}>Kod</th>
              <th style={s.th}>Agent</th>
              <th style={s.th}>Opis</th>
              <th style={s.th}>Zahtev</th>
              <th style={{ ...s.th, textAlign: 'center' }}>Snimci</th>
              <th style={{ ...s.th, textAlign: 'center' }}>Poruke</th>
              <th style={{ ...s.th, textAlign: 'right' }}>Akcija</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} style={s.empty}>Učitavanje...</td></tr>}
            {!loading && sessions.length === 0 && <tr><td colSpan={8} style={s.empty}>Nema sesija</td></tr>}
            {!loading && sessions.map(sess => (
              <tr key={sess.code}>
                <td style={s.td}>
                  <input type="checkbox" checked={selected.has(sess.code)} onChange={() => toggleSelect(sess.code)} />
                </td>
                <td style={s.td}><strong style={{ fontFamily: 'monospace' }}>{sess.code}</strong></td>
                <td style={s.td}>{sess.agent_username || '—'}</td>
                <td style={{ ...s.td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {sess.description || <span style={{ color: '#999' }}>bez opisa</span>}
                </td>
                <td style={s.td}>{formatDate(sess.requested_at)}</td>
                <td style={{ ...s.td, textAlign: 'center' }}>{sess.screenshot_count}</td>
                <td style={{ ...s.td, textAlign: 'center' }}>{sess.message_count}</td>
                <td style={{ ...s.td, textAlign: 'right' }}>
                  <button style={{ ...s.actionBtn, color: '#791F1F', borderColor: '#F09595' }} onClick={() => deleteSingleSession(sess.code)}>
                    Obriši
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ ...s.headerRow, marginTop: 32 }}>
        <div style={s.sectionTitle}>Audit log — brisanje</div>
      </div>
      <div style={s.filterRow}>
        <input style={s.filterInput} placeholder="Tip događaja..." value={auditEventType} onChange={e => setAuditEventType(e.target.value)} />
        <input style={s.filterInput} placeholder="Ko (actor)..." value={auditActor} onChange={e => setAuditActor(e.target.value)} />
        <input style={s.filterInput} type="date" value={auditDateFrom} onChange={e => setAuditDateFrom(e.target.value)} title="Od datuma" />
        <input style={s.filterInput} type="date" value={auditDateTo} onChange={e => setAuditDateTo(e.target.value)} title="Do datuma" />
        <button style={s.btn('danger')} onClick={() => deleteAuditFiltered(false)}>Obriši po filteru</button>
        <button style={s.btn('danger')} onClick={() => deleteAuditFiltered(true)}>Obriši ceo audit log</button>
      </div>
    </>
  );
}

// ============ TAB: OCENE ============

function RatingsTab({ token, styles: s }) {
  const [ratings, setRatings] = useState([]);
  const [stats, setStats] = useState(null);
  const [perAgent, setPerAgent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [agentFilter, setAgentFilter] = useState('');
  const [agentsList, setAgentsList] = useState([]);

  useEffect(() => {
    fetch(`${SERVER_URL}/api/admin/agents`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json()).then(setAgentsList).catch(() => {});
  }, [token]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const qs = agentFilter ? `?agent=${encodeURIComponent(agentFilter)}` : '';
    const [ratingsRes, statsRes, perAgentRes] = await Promise.all([
      fetch(`${SERVER_URL}/api/ratings${qs}`, { headers: { 'Authorization': `Bearer ${token}` } }),
      fetch(`${SERVER_URL}/api/ratings/stats${qs}`, { headers: { 'Authorization': `Bearer ${token}` } }),
      fetch(`${SERVER_URL}/api/ratings/per-agent`, { headers: { 'Authorization': `Bearer ${token}` } })
    ]);
    setRatings(await ratingsRes.json());
    setStats(await statsRes.json());
    setPerAgent(await perAgentRes.json());
    setLoading(false);
  }, [token, agentFilter]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const formatDate = (iso) => new Date(iso).toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  const avgDisplay = stats?.avg_rating != null ? Number(stats.avg_rating).toFixed(1) : '—';

  return (
    <>
      <div style={s.statCards}>
        <div style={s.statCard}>
          <div style={{ ...s.statValue, color: '#F5A623' }}>{avgDisplay} {stats?.avg_rating != null && '★'}</div>
          <div style={s.statLabel}>Prosečna ocena</div>
        </div>
        <div style={s.statCard}><div style={s.statValue}>{stats?.total_ratings ?? 0}</div><div style={s.statLabel}>Ukupno ocena</div></div>
        <div style={s.statCard}><div style={{ ...s.statValue, color: '#1D9E75' }}>{stats?.positive_count ?? 0}</div><div style={s.statLabel}>Pozitivne (4-5)</div></div>
        <div style={s.statCard}><div style={{ ...s.statValue, color: '#E24B4A' }}>{stats?.negative_count ?? 0}</div><div style={s.statLabel}>Negativne (1-2)</div></div>
      </div>

      {perAgent.length > 0 && (
        <>
          <div style={{ ...s.headerRow, marginTop: 8 }}>
            <div style={s.sectionTitle}>Prosek po agentu</div>
          </div>
          <div style={{ ...s.tableWrap, marginBottom: 24 }}>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Agent</th>
                  <th style={s.th}>Prosečna ocena</th>
                  <th style={{ ...s.th, textAlign: 'center' }}>Broj ocena</th>
                </tr>
              </thead>
              <tbody>
                {perAgent.map(pa => (
                  <tr key={pa.agent_username}>
                    <td style={s.td}>{pa.agent_username}</td>
                    <td style={s.td}><span style={{ color: '#F5A623' }}>{renderStars(Math.round(pa.avg_rating))}</span> ({Number(pa.avg_rating).toFixed(1)})</td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{pa.total_ratings}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      <div style={s.headerRow}>
        <div style={s.sectionTitle}>Sve ocene ({ratings.length})</div>
        <div style={s.filterRow}>
          <select style={{ ...s.select, marginBottom: 0, width: 200 }} value={agentFilter} onChange={e => setAgentFilter(e.target.value)}>
            <option value="">Svi agenti</option>
            {agentsList.map(a => <option key={a.username} value={a.username}>{a.fullName || a.username}</option>)}
          </select>
        </div>
      </div>

      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Kod sesije</th>
              <th style={s.th}>Agent</th>
              <th style={s.th}>Ocena</th>
              <th style={s.th}>Komentar</th>
              <th style={s.th}>Datum</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} style={s.empty}>Učitavanje...</td></tr>}
            {!loading && ratings.length === 0 && <tr><td colSpan={5} style={s.empty}>Nema ocena</td></tr>}
            {!loading && ratings.map(r => (
              <tr key={r.id}>
                <td style={s.td}><strong style={{ fontFamily: 'monospace' }}>{r.session_code}</strong></td>
                <td style={s.td}>{r.agent_username || '—'}</td>
                <td style={s.td}><span style={{ color: '#F5A623' }}>{renderStars(r.rating)}</span></td>
                <td style={{ ...s.td, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {r.comment || <span style={{ color: '#999' }}>bez komentara</span>}
                </td>
                <td style={s.td}>{formatDate(r.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
